import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { put } from 'helpers/api';
import QuickbooksSelect from './select';

export default function QuickbooksBrokerVendorTable({ brokers }) {
  const [brokerQuickbooksIds, setBrokerQuickbooksIds] = useState(
    () => Object.fromEntries(brokers.map(b => [b.id, b.quickbooksId]))
  );

  function handleVendorChange(broker, vendor) {
    const quickbooksId = vendor ? parseInt(vendor.id, 10) : null;
    put(`/users/${broker.id}`, { user: { quickbooks_id: quickbooksId } }).then(() => {
      setBrokerQuickbooksIds(prev => ({ ...prev, [broker.id]: quickbooksId }));
    }).catch(() => { });
  }

  if (brokers.length === 0) {
    return <p>No brokers found for this company.</p>;
  }

  return (
    <table className="table" style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th style={{ width: '50%' }}>Broker in Buildout</th>
          <th style={{ width: '50%' }}>QuickBooks Vendor</th>
        </tr>
      </thead>
      <tbody>
        {brokers.map(broker => (
          <tr key={broker.id}>
            <td
              className="align-middle"
              style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {broker.name}
            </td>
            <td>
              <QuickbooksSelect
                buildoutObject={broker}
                quickbooksId={brokerQuickbooksIds[broker.id]}
                type="vendor"
                onChange={vendor => handleVendorChange(broker, vendor)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

QuickbooksBrokerVendorTable.propTypes = {
  brokers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quickbooksId: PropTypes.number,
  })).isRequired,
};
